export const TwitchConstants = {
    OFF: 0,
    LIVE: 1,
    VIDEO: 2,
    LIVE_KROMOW: 3,
    LIVE_TIKTOK: 4,
    LIVE_TERTULIA: 5,
    LIVE_PYLON: 6,
    LIVE_YOUTUBE_DONQUIOTE: 7,
};
